import React from 'react'
import {PageRouter} from './PageRouter'
import HomePage from '../pages/Home'
import PublicGlobePage from '../pages/PublicGlobe'
import PublicTripPage from '../pages/PublicTrip'
import SignInPage from '../pages/SignIn'
import ResetPasswordPage from '../pages/ResetPassword'
import SignUpPage from '../pages/SignUp'
import {PublicTripFotos} from './Trip'
import {AppToaster, DetailPanel} from '.'
import {About} from './Help'
import {AppBar, Box, Button, Container, Divider, Link, Toolbar} from '@mui/material'
import {IconHome, IconAbout, IconSignIn} from '../Icons'

function PublicMenu() {
  return (
    <AppBar position="static">
      <Container maxWidth="md">
        <Toolbar
          id="header"
          disableGutters
          sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}
        >
          <Box position="relative" pb="10px">
            <Link href="/">
              <img
                src="https://tfks.sfo3.digitaloceanspaces.com/fotolog/img/logo.png"
                alt="logo"
                height="33"
                className="app-clickable"
              />
            </Link>
            <Box
              position="absolute"
              right={0}
              bottom={0}
              color="common.white"
              fontWeight={700}
              sx={{fontVariant: 'all-small-caps'}}
            >
              <span role="img">❤</span> &nbsp; tfks
            </Box>
          </Box>
          <Box className="app-flex">
            <Button href="/" color="inherit">
              <IconHome />
              <span className="app-hide-sm"> &nbsp; Home</span>
            </Button>
            <Divider orientation="vertical" variant="middle" flexItem color="inherit" />
            <Button href="/signin" color="inherit">
              <IconSignIn />
              <span className="app-hide-sm"> &nbsp; Sign In</span>
            </Button>
            <Divider orientation="vertical" variant="middle" flexItem color="inherit" />
            <Button href="./about" color="inherit">
              <IconAbout />
              <span className="app-hide-sm"> &nbsp; About</span>
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  )
}

export default function PublicApp() {
  return (
    <div id="main" className="public">
      <AppToaster />
      <PublicMenu />
      <div id="body">
        <PageRouter
          routes={[
            {path: /^\/$/, page: HomePage, id: () => 'Home', fallback: true},
            {path: /^\/signup/, page: SignUpPage, id: () => 'Sign Up'},
            {path: /^\/signin\/reset/, page: ResetPasswordPage, id: () => 'Reset Password'},
            {path: /^\/signin/, page: SignInPage, id: () => 'Sign In'},
            {path: /^\/globe/, page: PublicGlobePage, id: () => 'Globe'},
            {
              path: /^\/trip\/(?<id>\d+)-?(?<slug>[-\w]+)?/,
              page: PublicTripPage,
              id: ({id, slug}) => `Trip : ${slug || id}`,
            },
          ]}
        />
        <DetailPanel
          path="(?<home>/trip/(?<trip>\d+)-?(?<slug>[-\w]+)?)/(?<foto>\d+)?$"
          panel={PublicTripFotos}
          title={({slug}) => ['Trip', slug, 'Details']}
          overlay={false}
        />
        <DetailPanel path="(?<home>.*)/about" panel={About} title={['About FotoLog']} />
      </div>
    </div>
  )
}
